import React, { useEffect, useState} from "react";

import Navbar from "../../components/navbar/Navbar";
import Header from "../../components/header/Header";
import Imagecontent from "../../components/imagecontent/Imagecontent";
import Maincontent from "../../components/maincontent/Maincontent";
import Footer from "../../containers/footer/Footer";

import "./homepage.css";

import { ClipLoader} from 'react-spinners'

import { useMsal } from "@azure/msal-react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import {InteractionStatus} from "@azure/msal-browser";

export default function Homepage() {

   //authenticate 
   const {instance,inProgress,accounts} = useMsal();
   const isAuthenticated = useIsAuthenticated();

   const request = { ...loginRequest,account: accounts[0]};
   const [accessToken,setAccessToken] = useState('');
   const [isLoading,setisLoading] =useState(true);



   if(inProgress === InteractionStatus.None && !isAuthenticated){
   
      if(accounts.length === 0){
        setTimeout(() => {
        if(inProgress === InteractionStatus.None)
        instance.loginRedirect(loginRequest).catch(e => { console.log(e);});
      },500);
      }
 
   }

   else if(isAuthenticated){
    // console.log('user is authenticated!');
    setTimeout(()=> {
      instance.acquireTokenSilent(request).then((response) => {
        setAccessToken(response.accessToken);
    }).then(()=>{
      setisLoading(false);
     console.log('token :'+accessToken)
    })
    .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
            setAccessToken(response.accessToken);
        });
    });
    },500)

   }
   
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return <div className="Home">
   <Header/>
   <Navbar makebold="HOME" />
   <Imagecontent title="Key Security Assistance"/>
   <AuthenticatedTemplate>
   <Maincontent accessToken={accessToken}/>
   {isLoading?<div><ClipLoader color="#000000" size={15}/> Loading...</div>:<Footer accessToken={accessToken}/>}
   </AuthenticatedTemplate>
 
  </div>;
}
